module.exports = __webpack_public_path__ + "img/KW_hoe.a1e9bdc3.png";